import React from 'react';
import './StatusPageWrapper.css';

export interface StatusPageWrapperDO {
  title: string;
  subTitle: string;
  msg: string;
  imgSrc?: string | undefined;
  errorCode: string;
  actionBtn?: React.JSX.Element | undefined;
}

export default function StatusPageWrapper({
  title,
  subTitle,
  msg,
  errorCode,
  actionBtn,
}: StatusPageWrapperDO) {
  return (
    <div className={'row g-0 muted'}>
      <div className="col-lg-7 mx-auto text-center">
        <div className="row g-0">
          <div className="col-md-12">
            <div className="title">{title}</div>
            <h4 className={'subtitle'}>{subTitle}</h4>
          </div>
          <div className="col-md-7 mx-auto">
            {errorCode && <h6 className={'error-code'}>Error Code: {errorCode}</h6>}
            <div className={'message'}>{msg}</div>
            {actionBtn && <div className="d-flex justify-content-center">{actionBtn}</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
